import { FinancialsWidgetViewModel } from '../../../../common/clientApi/ClientApiTypes';

export const areTextWidgetsEqual = (initData?: FinancialsWidgetViewModel, newData?: FinancialsWidgetViewModel) => {
    if (!newData || !initData) {
        return false;
    }
    
    return initData.title === newData.title && initData.textItemValue === newData.textItemValue;
};
